<template>
    <HeroWithImages :slice="props.slice" is-hero-with-search class="slice-hero--with-search">
        <template #search-panel>
            <div class="slice-hero--with-search__panel" data-testid="slice-hero-search">
                <SearchPanel
                    :search-tab="keywordSearchLinkText"
                    :search-field-category="slice.primary.categoryLabel"
                    :search-field-location="slice.primary.locationLabel"
                    :search-location-remote-country-label="slice.primary.remoteInCountryLabel"
                    :search-submit="keywordSearchLinkText"
                    :search-submit-link="keywordSearchLinkUrl"
                    :ai-search-tab="aiSearchLinkText"
                    :ai-search-tab-link="aiSearchLinkUrl"
                    brief-origin="home_unlogged"
                    page-source="home_unlogged_try_ai_search"
                    origin="USER_PROMPT_HOMEPAGE_UNLOGGED"
                />
            </div>
        </template>
    </HeroWithImages>
    <div class="slice-content slice-hero--with-search__reinsurance-wrapper">
        <MktReinsurancePanel
            :items="slice.primary.items"
            :trustpilot-data-locale="`${slice.primary.trustpilotDataLocale}`"
            :trustpilot-data-template-id="`${slice.primary.trustpilotDataTemplateId}`"
            :trustpilot-data-businessunit-id="`${slice.primary.trustpilotDataBusinessunitId}`"
            :trustpilot-link="slice.primary.trustpilotLink"
            :hide-trustpilot="!!slice.primary.hideTrustpilot"
        />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {HeroSlice, HeroSliceHeroWithSearch} from '@prismicio-types';
    import SearchPanel from '@search/components/SearchPanel.vue';
    import HeroWithImages from './HeroWithImages.vue';
    import MktReinsurancePanel from '../../../components/reassurance/ReinsurancePanel.vue';

    const props = defineProps(getSliceComponentProps<HeroSlice>());
    const slice = computed(() => props.slice as HeroSliceHeroWithSearch);

    const searchLink = computed(() => {
        if (!isFilled.link(slice.value.primary.searchLink)) return undefined;
        return slice.value.primary.searchLink as {url?: string; text?: string};
    });

    const submitProjectLink = computed(() => {
        if (!isFilled.link(slice.value.primary.submitProject)) return undefined;
        return slice.value.primary.submitProject as {url?: string; text?: string};
    });

    const keywordSearchLinkText = computed(() => submitProjectLink.value?.text ?? undefined);
    const keywordSearchLinkUrl = computed(() => submitProjectLink.value?.url ?? undefined);
    const aiSearchLinkText = computed(() => searchLink.value?.text ?? undefined);
    const aiSearchLinkUrl = computed(() => searchLink.value?.url ?? undefined);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    .slice-hero {
        &--with-search {
            background-image: url('../../../../assets/svg/hero-with-search-shapes.svg');
            background-position: bottom center;
            background-size: cover;

            .slice-hero__description,
            .slice-hero__title h1 {
                color: var(--joy-color-neutral-0);
            }

            @include mq.screen_md(min) {
                background-image: none;
                .slice-hero__description,
                .slice-hero__title h1 {
                    color: initial;
                }
            }

            &__panel {
                width: 100%;
                margin-top: 48px;
            }

            &__reinsurance-wrapper {
                padding-top: 0;
                padding-bottom: 0;
            }
        }
    }
</style>
